import { fields } from './constants';

const validateExpiryDate = (valueToTest) => {
  const today = new Date();
  const inputValues = valueToTest.split('/');

  const currentMonth = new Date(today.getFullYear(), today.getMonth(), 1).valueOf();
  const inputYear = inputValues[1].length === 4 ? inputValues[1] : 2000 + parseInt(inputValues[1], 10);
  const inputMonth = new Date(inputYear, parseInt(inputValues[0], 10) - 1, 1).valueOf();
  if (inputMonth <= currentMonth) {
    return false;
  }
  return true;
};

export const validateCardNumber = (cardNumber) => {
  if (!cardNumber) {
    return false;
  }

  const length = cardNumber.length;
  let odd = false;
  let total = 0;
  let calc;
  let calc2;

  if (!/^[0-9]+$/.test(cardNumber)) {
    return false;
  }

  if (length < 12 || length > 19) {
    return false;
  }

  //  This performs a check on a credit card number to see if it is valid according to the Luhn algorithm,
  //  which is used to validate a variety of identification numbers, including credit card numbers.
  for (let i = length; i > 0; i--) {
    calc = parseInt(cardNumber.charAt(i - 1), 10);
    if (!odd) {
      total += calc;
    } else {
      calc2 = calc * 2;

      switch (calc2) {
        case 10:
          calc2 = 1;
          break;
        case 12:
          calc2 = 3;
          break;
        case 14:
          calc2 = 5;
          break;
        case 16:
          calc2 = 7;
          break;
        case 18:
          calc2 = 9;
          break;
        default:
          break;
      }
      total += calc2;
    }
    odd = !odd;
  }
  return total !== 0 && total % 10 === 0;
};

export const handleFormFieldValidation = (name, value) => {
  let error = false;
  const valueToTest = value?.trim() || '';
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  const phoneRegex = /^\+?([0-9][-\s]?){9,14}[0-9]$/;

  switch (name) {
    case fields.accountNickName:
    case fields.cardName:
    case fields.city:
    case fields.line1:
    case fields.name:
    case fields.postalCode:
      if (valueToTest.length < 2) {
        error = true;
      }
      break;
    case fields.phone:
      if (!phoneRegex.test(valueToTest)) {
        error = true;
      }
      break;
    case fields.email:
      if (!emailRegex.test(valueToTest)) {
        error = true;
      }
      break;
    case fields.cardNumber:
      if (!validateCardNumber(valueToTest)) {
        error = true;
      }
      break;
    case fields.expiry:
      if (!/^(0[1-9]|1[0-2])\/(2[1-9]|[3-9][0-9]|202[1-9]|20[3-9][0-9])$/.test(valueToTest)) {
        error = true;
      } else if (!validateExpiryDate(valueToTest)) {
        error = true;
      }
      break;
    case fields.cvv:
      if (![3, 4].includes(valueToTest.length)) {
        error = true;
      }
      break;
    case fields.ianaTimeZone:
    case fields.cardProvider:
    case fields.countryCode:
    case fields.state:
      if (!value || value === '') {
        error = true;
      }
      break;
    default:
      break;
  }
  return error;
};

export const handleFormValidation = (allFields, values) => {
  const errorObj = {};
  Object.values(allFields).forEach((field) => {
    errorObj[field] = handleFormFieldValidation(field, values[field]);
  });
  return errorObj;
};
